<div class="col-lg-auto durations py-0 p-lg-2">
  <a href="javascript:void(0)" [class.active]="duration === PriceChartDuration.OneDay" (click)="changeDuration(PriceChartDuration.OneDay)">
    <span class="d-none d-lg-inline" i18n="@@pricePage.chart.durations.24hours">24 Hours</span>
    <span class="d-lg-none" i18n="@@pricePage.chart.durations.24h">24H</span>
  </a>
  <span class="spacer"></span>
  <a href="javascript:void(0)" [class.active]="duration === PriceChartDuration.SevenDays" (click)="changeDuration(PriceChartDuration.SevenDays)">
    <span class="d-none d-lg-inline" i18n="@@pricePage.chart.durations.7days">7 Days</span>
    <span class="d-lg-none" i18n="@@pricePage.chart.durations.7d">7D</span></a>
  <span class="spacer"></span>
  <a href="javascript:void(0)" [class.active]="duration === PriceChartDuration.OneMonth" (click)="changeDuration(PriceChartDuration.OneMonth)">
    <span class="d-none d-lg-inline" i18n="@@pricePage.chart.durations.1month">1 Month</span>
    <span class="d-lg-none" i18n="@@pricePage.chart.durations.1m">1M</span>
  </a>
  <span class="spacer"></span>
  <a href="javascript:void(0)" [class.active]="duration === PriceChartDuration.ThreeMonths" (click)="changeDuration(PriceChartDuration.ThreeMonths)">
    <span class="d-none d-lg-inline" i18n="@@pricePage.chart.durations.3months">3 Months</span>
    <span class="d-lg-none" i18n="@@pricePage.chart.durations.3m">3M</span></a>
  <span class="spacer"></span>
  <a href="javascript:void(0)" [class.active]="duration === PriceChartDuration.OneYear" (click)="changeDuration(PriceChartDuration.OneYear)">
    <span class="d-none d-lg-inline" i18n="@@pricePage.chart.durations.1year">1 Year</span>
    <span class="d-lg-none" i18n="@@pricePage.chart.durations.1y">1Y</span>
  </a>
</div>
